var actions_trcl_html = require('./bootstrap/actions-trcl.html');
var actions_html = require('./bootstrap/actions.html');
var array_html = require('./bootstrap/array.html');
var checkbox_html = require('./bootstrap/checkbox.html');
var checkboxes_html = require('./bootstrap/checkboxes.html');
var default_html = require('./bootstrap/default.html');
var fieldset_html = require('./bootstrap/fieldset.html');
var help_html = require('./bootstrap/help.html');
var radio_buttons_html = require('./bootstrap/radio-buttons.html');
var radios_inline_html = require('./bootstrap/radios-inline.html');
var radios_html = require('./bootstrap/radios.html');
var section_html = require('./bootstrap/section.html');

var select_html = require('./bootstrap/select.html');
var select_countries_html = require('./bootstrap/select-countries.html');
var select_multi_html = require('./bootstrap/select-multi.html');
var select_multi_async_html = require('./bootstrap/select-multi-async.html');
var select_multi_async_by_groups_html = require('./bootstrap/select-multi-async-by-groups.html');

var submit_html = require('./bootstrap/submit.html');
var tabarray_html = require('./bootstrap/tabarray.html');
var tabs_html = require('./bootstrap/tabs.html');
var tabs_vertical_html = require('./bootstrap/tabs-vertical.html');
var textarea_html = require('./bootstrap/textarea.html');

var date_html = require('./bootstrap/date.html');
var daterange_html = require('./bootstrap/daterange.html');
var datetime_html = require('./bootstrap/datetime.html');
var json_html = require('./bootstrap/json.html');
var upload_file_html = require('./bootstrap/upload-file.html');

var app = angular.module("schemaForm");

app.run(["$templateCache", function ($templateCache) {
    $templateCache.put("decorators/bootstrap/actions-trcl.html", actions_trcl_html);
    $templateCache.put("decorators/bootstrap/actions.html", actions_html);
    $templateCache.put("decorators/bootstrap/array.html", array_html);
    $templateCache.put("decorators/bootstrap/checkbox.html", checkbox_html);
    $templateCache.put("decorators/bootstrap/checkboxes.html", checkboxes_html);
    $templateCache.put("decorators/bootstrap/default.html", default_html);
    $templateCache.put("decorators/bootstrap/fieldset.html", fieldset_html);
    $templateCache.put("decorators/bootstrap/help.html", help_html);
    $templateCache.put("decorators/bootstrap/radio-buttons.html", radio_buttons_html);
    $templateCache.put("decorators/bootstrap/radios-inline.html", radios_inline_html);
    $templateCache.put("decorators/bootstrap/radios.html", radios_html);
    $templateCache.put("decorators/bootstrap/section.html", section_html);

    $templateCache.put("decorators/bootstrap/select.html", select_html);
    $templateCache.put("decorators/bootstrap/select-countries.html", select_countries_html);
    $templateCache.put("decorators/bootstrap/select-multi.html", select_multi_html);
    $templateCache.put("decorators/bootstrap/select-multi-async.html", select_multi_async_html);
    $templateCache.put("decorators/bootstrap/select-multi-async-by-groups.html", select_multi_async_by_groups_html);

    $templateCache.put("decorators/bootstrap/submit.html", submit_html);
    $templateCache.put("decorators/bootstrap/tabarray.html", tabarray_html);
    $templateCache.put("decorators/bootstrap/tabs.html", tabs_html);
    $templateCache.put("decorators/bootstrap/tabs-vertical.html", tabs_vertical_html);
    $templateCache.put("decorators/bootstrap/textarea.html", textarea_html);

    $templateCache.put("decorators/bootstrap/date.html", date_html);
    $templateCache.put("decorators/bootstrap/daterange.html", daterange_html);
    $templateCache.put("decorators/bootstrap/datetime.html", datetime_html);
    $templateCache.put("decorators/bootstrap/json.html", json_html);
    $templateCache.put("decorators/bootstrap/upload-file.html", upload_file_html);
}]);

app.config(['schemaFormDecoratorsProvider', 'sfBuilderProvider', 'sfPathProvider',
    function (decoratorsProvider, sfBuilderProvider, sfPathProvider) {
        var base = 'decorators/bootstrap/';

        var simpleTransclusion = sfBuilderProvider.builders.simpleTransclusion;
        var ngModelOptions = sfBuilderProvider.builders.ngModelOptions;
        var ngModel = sfBuilderProvider.builders.ngModel;
        var sfField = sfBuilderProvider.builders.sfField;
        var condition = sfBuilderProvider.builders.condition;
        var array = sfBuilderProvider.builders.array;

        // Tabs is so bootstrap specific that it stays here.
        var tabs = function (args) {
            if (args.form.tabs && args.form.tabs.length > 0) {
                var tabContent = args.fieldFrag.querySelector('.tab-content');

                args.form.tabs.forEach(function (tab, index) {
                    var div = document.createElement('div');
                    div.className = 'tab-pane';
                    div.setAttribute('ng-disabled', 'form.readonly');
                    div.setAttribute('ng-show', 'selected.tab === ' + index);
                    div.setAttribute('ng-class', '{active: selected.tab === ' + index + '}');

                    var childFrag = args.build(tab.items, args.path + '.tabs[' + index + '].items', args.state);
                    div.appendChild(childFrag);
                    tabContent.appendChild(div);
                });
            }
        };

        var defaults = [sfField, ngModel, ngModelOptions, condition];
        decoratorsProvider.defineDecorator('bootstrapDecorator', {
            textarea: {template: base + 'textarea.html', builder: defaults},
            fieldset: {template: base + 'fieldset.html', builder: [sfField, simpleTransclusion, condition]},
            array: {template: base + 'array.html', builder: [sfField, ngModelOptions, ngModel, array, condition]},
            tabarray: {template: base + 'tabarray.html', builder: [sfField, ngModelOptions, ngModel, array, condition]},

            tabs: {template: base + 'tabs.html', builder: [sfField, ngModelOptions, tabs, condition]},
            'tabs-vertical': {
                template: base + 'tabs-vertical.html',
                builder: [sfField, ngModelOptions, tabs, condition]
            },

            section: {template: base + 'section.html', builder: [sfField, simpleTransclusion, condition]},
            conditional: {template: base + 'section.html', builder: [sfField, simpleTransclusion, condition]},
            actions: {template: base + 'actions.html', builder: defaults},

            select: {template: base + 'select.html', builder: defaults},
            'select-countries': {template: base + 'select-countries.html', builder: defaults},
            'select-multi': {template: base + 'select-multi.html', builder: defaults},
            'select-multi-async': {template: base + 'select-multi-async.html', builder: defaults},
            'select-multi-async-by-groups': {template: base + 'select-multi-async-by-groups.html', builder: defaults},

            checkbox: {template: base + 'checkbox.html', builder: defaults},
            checkboxes: {
                template: base + 'checkboxes.html',
                builder: [sfField, ngModelOptions, ngModel, array, condition]
            },
            number: {template: base + 'default.html', builder: defaults},
            password: {template: base + 'default.html', builder: defaults},
            submit: {template: base + 'submit.html', builder: defaults},
            button: {template: base + 'submit.html', builder: defaults},
            radios: {template: base + 'radios.html', builder: defaults},
            'radios-inline': {template: base + 'radios-inline.html', builder: defaults},
            radiobuttons: {template: base + 'radio-buttons.html', builder: defaults},
            help: {template: base + 'help.html', builder: defaults},
            date: {template: base + 'date.html', builder: defaults},
            daterange: {template: base + 'daterange.html', builder: defaults},
            datetime: {template: base + 'datetime.html', builder: defaults},
            json: {template: base + 'json.html', builder: defaults},
            upload_file: {template: base + 'upload-file.html', builder: defaults},
            'default': {template: base + 'default.html', builder: defaults}
        }, []);

    }]);


app.controller('SelectCountriesCtrl', ['$scope', 'HelpersApiService',
    function ($scope, HelpersApiService) {
        $scope.countries = [];
        $scope.updateCountries = function (search, raw_value) {
            if (search) {
                HelpersApiService
                    .countries({action: 'search', value: raw_value || [], search: search})
                    .then(function (resp) {
                        $scope.countries = resp;
                    })

            } else {
                HelpersApiService
                    .countries({action: 'init', value: raw_value || [], search: ''})
                    .then(function (resp) {
                        $scope.countries = resp;
                    });
            }
        }
    }]);

app.controller('SelectMultyAsyncCtrl', ['$scope', 'jsonrpc', function ($scope, jsonrpc) {
    $scope.title_map = [];

    $scope.updateTitleMap = function (search, service, method, raw_value) {
        var _method = jsonrpc.newService(service).createMethod(method);
        if (search) {
            _method({action: 'search', value: raw_value || [], search: search})
                .then(function (resp) {
                    $scope.title_map = resp;
                })

        } else {
            _method({action: 'init', value: raw_value || [], search: ''})
                .then(function (resp) {
                    $scope.title_map = resp;
                });
        }
    }
}
]);


app.controller('SelectMultyAsyncByGroupCtrl', ['$scope', 'jsonrpc', function ($scope, jsonrpc) {
    $scope.title_map = [];

    $scope.updateTitleMap = function (search, service, method, raw_value) {
        var _method = jsonrpc.newService(service).createMethod(method);
        if (search) {
            _method({action: 'search', value: raw_value || [], search: search})
                .then(function (resp) {
                    $scope.title_map = resp;
                })

        } else {
            _method({action: 'init', value: raw_value || [], search: ''})
                .then(function (resp) {
                    $scope.title_map = resp;
                });
        }
    }

    $scope.on_change_group = function (value, service, method, model) {
        model.items = [];
        $scope.updateTitleMap(value.value, service, method, []);
    }
    $scope.on_change_items = function (value, model) {
        //
    }
}
]);

var moment = require('moment');

app.controller('DateRangeCtrl', ['$scope',
    function ($scope) {
        const d1 = () => moment().startOf('day');
        const d2 = () => moment().endOf('day');
        $scope.ranges = {
            'Last 7 Days': [d1().subtract(6, 'days'), d2()],
            'Last 30 Days': [d1().subtract(29, 'days'), d2()],
            'Last 60 Days': [d1().subtract(59, 'days'), d2()],
            'Last 90 Days': [d1().subtract(89, 'days'), d2()],
            'This Month': [d1().startOf('month'), d2()],
            'Prev Month': [
                d1().subtract(1, 'month').startOf('month'),
                d1().subtract(1, 'month').endOf('month'),
            ],
            'Last 6 Month': [d1().subtract(6, 'month'), d2()],
            'Last 12 Month': [d1().subtract(12, 'month'), d2()],
            'This Year': [d1().startOf('year'), d2()],
            'Prev Year': [
                d1().subtract(1, 'year').startOf('year'),
                d1().subtract(1, 'year').endOf('year'),
            ],
        };
    }]);


app.controller('AdminFormUploadFilesField', ['$scope', 'Upload', '$timeout', function ($scope, Upload, $timeout) {
    $scope.uploadFiles = function(file, errFiles, upload_url, to_model) {
        $scope.f = file;
        $scope.errFile = errFiles && errFiles[0];
        if (file) {
            file.upload = Upload.upload({
                url: upload_url,
                data: {file: file}
            });

            file.upload.then(function (response) {
                $timeout(function () {
                    to_model.upload_result = response.data;
                    file.result = response;
                });
            }, function (response) {
                if (response.status > 0)
                    $scope.errorMsg = response.status + ': ' + response.data;
            }, function (evt) {
                file.progress = Math.min(100, parseInt(100.0 *
                                         evt.loaded / evt.total));
            });
        }
    }


}]);
